import Repository from "@/plugins/axios";

export default {
  // Получить стартовую (главную) страницу
  getMain() {
    return Repository.get("/biennale/main");
  },
};
